
// Import css files
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import askimg from "../../../../assets/homeimages/askbtn.svg";
import { Trans, useTranslation } from "react-i18next";
import 'aos/dist/aos.css';
import expiryclock from '../../../../assets/images/expiryclock.svg';
import insuuranceicon from '../../../../assets/askTheExpertImages/insurancemenuicon.svg';
import bulbblog from '../../../../assets/images/bulbblog.png';
import bulbblogim from '../../../../assets/images/insuranceblogone.png';
import React, { useEffect } from 'react';

import './articleDetails.css'; 
import { convertToCanadianDateTime, decodeHtmlEntities } from "../../../../shared/helper";
import TextWithBreaks from "../../../../shared/lineBreak";

const InsuranceArticleDetailsJsx = (props) => {
  const {
    detailsData,
  } = props;


  const { t } = useTranslation();



  useEffect(() => {
   
    window.scrollTo(0, 0);
  }, [])



  return (
    <>

      <section className={`homecustomblog blog-details ${detailsData?.['_embedded']?.['wp:term']?.[0]?.[0]?.slug}`}>
      <div className="homecustomblogbanner">
        <div className="container">
          <div className="row">
            <div className="col-lg-5 col-sm-5">
            <div className="herosectionblogdetail">
            <div className="herosectionbanner">
              <img src={`${detailsData?.acf?.banner_sectionn.image}`} alt="bannerimage"/>
              <div className="d-flex basicuserdetails">
                <div className="userimage">
                  <img src={`https://ui-avatars.com/api/?name=${detailsData?.['_embedded']?.['author']?.[0]?.name}&rounded=true`} alt={`${detailsData?.['_embedded']?.['author']?.[0]?.name}`} />
                </div>
                <div className="name">{detailsData?.['_embedded']?.['author']?.[0]?.name}</div>
              </div>
            </div>
          </div>
            </div>
            <div className="col-lg-7 col-sm-7">
            <div className={`herosectioncaption `}>
             <div className="heromain">
             <div className="heromainimg pb-4"><img src={bulbblogim} alt="bulbblogim"/></div>
              <h4 className="articlesubheading"><span><img src={insuuranceicon} alt="insurance Icon"/></span>{detailsData?.['_embedded']?.['wp:term']?.[0]?.[0]?.name}</h4>
              <h2 className="articleTitle">{decodeHtmlEntities(detailsData?.title?.rendered)}</h2>
              <div className="shortcontent" ><p>{detailsData?.acf?.banner_sectionn.short_description}</p></div>
              </div>
              <div className="articlepart" >
                <div className="d-block d-lg-none d-sm-none d-md-none">
              <div className="d-flex basicuserdetails">
                <div className="userimage">
                  <img src={`https://ui-avatars.com/api/?name=${detailsData?.['_embedded']?.['author']?.[0]?.name}&rounded=true`} alt={`${detailsData?.['_embedded']?.['author']?.[0]?.name}`} />
                </div>
                <div className="name">{detailsData?.['_embedded']?.['author']?.[0]?.name}</div>
              </div>
              </div>
              <p className="articlepublishdate "><span><img src={expiryclock} alt="clock"/></span>{convertToCanadianDateTime(detailsData?.date)}</p>
            </div>
            </div>
            </div>
          </div>
          </div>
          </div>
          <div className="settwoblogdiv">
            <div className="row">
              <h2 className="disab">{detailsData?.acf?.info_block?.overlay_title}</h2>
              <div className="col-lg-3 col-sm-3">
                <div className="blogimone">
                  <img src={detailsData?.acf?.info_block?.info_block_1?.image}  alt="blogimage"/>
                  <div className="blognum">01</div>
                </div>
                <div className="blogsubdivtext">
                {detailsData?.acf?.info_block?.info_block_1?.description}
                </div>
              </div>
              <div className="col-lg-3 col-sm-3">
                <div className="blogimone">
                <img src={detailsData?.acf?.info_block?.info_block_2?.image} alt="blogimage"/>
                  <div className="blognum">02</div>
                </div>
                <div className="blogsubdivtext">
                {detailsData?.acf?.info_block?.info_block_2?.description}
                </div>
              </div>
              <div className="col-lg-3 col-sm-3">
                <div className="blogimone">
                <img src={detailsData?.acf?.info_block?.info_block_3?.image} alt="blogimage"/>
                  <div className="blognum">03</div>
                </div>
                <div className="blogsubdivtext">
                {detailsData?.acf?.info_block?.info_block_3?.description}
                </div>
              </div>
              <div className="col-lg-3 col-sm-3">
                <div className="blogimone">
                <img src={detailsData?.acf?.info_block?.info_block_4?.image} alt="blogimage"/>
                  <div className="blognum">04</div>
                </div>
                <div className="blogsubdivtext">
                {detailsData?.acf?.info_block?.info_block_4?.description}
                </div>
              </div>
            </div>
          </div>
          <div className="blogsectionthree">
            <div className="row">
              <div className="col-lg-4 blogsectionthreeleft" style={{background:`url(${detailsData?.acf?.definition_block?.background_image})`}}>
                <div className="settwomainshoecasediv">
                  <h4>{detailsData?.acf?.definition_block?.title}</h4>
                  <p>{detailsData?.acf?.definition_block?.description}</p>
                </div>
              </div>
              <div className="col-lg-8 rightblogdetailssection">
                <div className="row">
                  <div className="col-lg-2">
                    <div className="blogsectionthreeimage">
                      <img src={detailsData?.acf?.definition_block?.block_section?.info_blocks?.info_block_1?.image} alt="blogimage"/>
                    </div>
                  </div>
                  <div className="col-lg-10">
                    <h4 className="heading">
                    {detailsData?.acf?.definition_block?.block_section?.info_blocks?.info_block_1?.title}
                    </h4>
                    <p>
                    {detailsData?.acf?.definition_block?.block_section?.info_blocks?.info_block_1?.desciption}
                    </p>
                  </div>
                </div>
                <div className="row">
                  <div className="col-lg-2">
                    <div className="blogsectionthreeimage">
                      <img src={detailsData?.acf?.definition_block?.block_section?.info_blocks?.info_block_2?.image} alt="blogimage"/>
                    </div>
                  </div>
                  <div className="col-lg-10">
                    <h4 className="heading">
                    {detailsData?.acf?.definition_block?.block_section?.info_blocks?.info_block_2?.title}
                    </h4>
                    <p>
                    {detailsData?.acf?.definition_block?.block_section?.info_blocks?.info_block_2?.desciption}
                    </p>
                  </div>
                </div>
                <div className="row">
                  <div className="col-lg-2">
                    <div className="blogsectionthreeimage">
                      <img src={detailsData?.acf?.definition_block?.block_section?.info_blocks?.info_block_3?.image} alt="blogimage"/>
                    </div>
                  </div>
                  <div className="col-lg-10">
                    <h4 className="heading">
                    {detailsData?.acf?.definition_block?.block_section?.info_blocks?.info_block_3?.title}
                    </h4>
                    <p>
                    {detailsData?.acf?.definition_block?.block_section?.info_blocks?.info_block_3?.desciption}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="blogaskexpert">
            <div className="row">
              <div className="col-lg-7 d-flex  align-items-center">
                <span><img src={bulbblog} alt="bulb" /></span>
                <h3>
                  <Trans i18nKey={t("COMMON.BLOGTAG")}></Trans> "{detailsData?.acf?.pro_tip_section?.pro_tip}"
              </h3>
              </div>
              <div className="col-lg-5 d-flex justify-content-end">
              <Link to={'/AskTheExpert'}>
                            <div className={`askbutton`}>
                                <p className={`askres mb-0`}>{t("COMMON.ASKTHEEXPERTS")}</p>
                                <img src={askimg} alt="Ask now" />
                            </div>
                        </Link>              </div>
            </div>
          </div>
          <div className="blogsectionfour isurance">
            <h2>{detailsData?.acf?.how_to_block?.title}</h2>
            <div className="row">
              <div className="col-lg-3 col-sm-3">
                <div className="blogsecfourleft">                  
                  <img src={detailsData?.acf?.how_to_block?.left_image} alt="blogimage"/>
                </div>
              </div>
              <div className="col-lg-9 col-sm-9 blogsecfourrightps" >
                <div className="blogsecfourright">
                 <div className="row">
                   <div className="col-lg-4 col-sm-4">
                   <div className="blogsecfourrightinner">
                     <div className="heading">
                     {detailsData?.acf?.how_to_block?.info_block_1?.title}
                     </div>
                     <p>
                       <TextWithBreaks text={detailsData?.acf?.how_to_block?.info_block_1?.description} />                     
                     </p>
                   </div>
                   </div>
                   <div className="col-lg-4 col-sm-4">
                   <div className="blogsecfourrightinner">
                     <div className="heading">
                     {detailsData?.acf?.how_to_block?.info_block_2?.title}
                     </div>
                     <p>
                     <TextWithBreaks text={detailsData?.acf?.how_to_block?.info_block_2?.description} />                     
                     </p>
                   </div>
                   </div>
                   <div className="col-lg-4 col-sm-4">
                   <div className="blogsecfourrightinner">
                     <div className="heading">
                     {detailsData?.acf?.how_to_block?.info_block_3?.title}
                     </div>
                     <p>
                     <TextWithBreaks text={detailsData?.acf?.how_to_block?.info_block_3?.description} />                     
                     </p>
                   </div>
                   </div>
                 </div>
                </div>
              </div>
            </div>
          </div>
          <div className="blogsectionfive">
            <div className="blogsectionfiveimage"  style={{background:`url(${detailsData?.acf?.overlay_banner_section?.image})`}}>
              {/* <img src={detailsData?.acf?.overlay_banner_section?.image} alt="blogimage"/> */}
              <div className="blogsectionfivecaption">
                <h2>{detailsData?.acf?.overlay_banner_section?.title} </h2>
                <p>{detailsData?.acf?.overlay_banner_section?.description}</p>
              </div>
            </div>
            <div className="blogsectionfivetext">
              <div className="row">
                <div className="col-lg-4 col-sm-4 ">
                  <div className="blogsectionfivesegment">
                  <div className="blogsectionfivesegmentleft">A</div>
                  <div className="blogsectionfivesegmentright">
                  <h4>{detailsData?.acf?.features_section?.info_block_1?.title}</h4>
                  <p>{detailsData?.acf?.features_section?.info_block_1?.description}</p>
                  </div>
                  </div>
                 
                </div>
                <div className="col-lg-4 col-sm-4 ">
                  <div className="blogsectionfivesegment">
                  <div className="blogsectionfivesegmentleft">B</div>
                  <div className="blogsectionfivesegmentright">
                  <h4>{detailsData?.acf?.features_section?.info_block_2?.title}</h4>
                  <p>{detailsData?.acf?.features_section?.info_block_2?.description}</p>
                  </div>
                  </div>
                 
                </div>
                <div className="col-lg-4 col-sm-4 ">
                  <div className="blogsectionfivesegment">
                  <div className="blogsectionfivesegmentleft">C</div>
                  <div className="blogsectionfivesegmentright">
                  <h4>{detailsData?.acf?.features_section?.info_block_3?.title}</h4>
                  <p>{detailsData?.acf?.features_section?.info_block_3?.description}</p>
                  </div>
                  </div>               
                </div>
              </div>
            </div>
          </div>      
          <div className="blogdisclaimer">
       <div className="disclaimerinner">
         <h2>{t("COMMON.Disclaimer_heading")}</h2>
         <p>{t("COMMON.Disclaimer_text")}</p>
       </div>
       </div>
      </section>
   
    </>

  );
};

export default InsuranceArticleDetailsJsx;